import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { MyListingsService } from '../../services/my-listings.service';
import { ListingCheckoutService } from '../../services/listing-checkout.service';
import { LoginService } from '../../services/login.service';
import { CookieService } from "ngx-cookie-service";
import { ToastService } from '../../services/toast.service';
import { UserState } from 'src/state/user.state';
import { UserService } from 'src/app/services/user.service';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/app.state';
import { CookieStorageService } from 'src/app/services/cookie-storage.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  isNaveEnabled: boolean = false;
  isBuy: boolean = false;
  isSell: boolean = false;
  showSearch: boolean = false;
  isLoggedIn = false;
  isButtonLoader: boolean = false;
  path: string;
  onDestroyNotifier$ = new Subject();

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public listingCheckoutService: ListingCheckoutService,
    public loginService: LoginService,
    private cookieService: CookieService,
    private cookieStorageService: CookieStorageService,
    public toastService: ToastService,
    public userState: UserState,
    private userService: UserService,
    public appState: AppState,
  ) { }

  displayname: any;
  historyState: any;
  companyInfo: any;
  websiteUrl: string;

  @Output() loadListings = new EventEmitter<void>();

  ngOnInit(): void {

    this.appState.companyInfo$.subscribe((res) => {
      if (res) {
        this.companyInfo = res;
        this.websiteUrl = this.companyInfo.sellSideConfig?.websiteUrl;
      }
    });

    this.path = '';
    if (this.router.url) {
      this.path = this.router.url.split('?')[0];
      if (this.path == '/search' || this.path == '/my-listing') {
        this.showSearch = true;
      } else {
        this.showSearch = false;
      }
    }

    this.historyState = history.state;

    let cIdToken = null;
    let cRefreshToken = null;
    let cAccessToken = null;

    const cookieExists: boolean = this.cookieService.check("idToken");
    if (cookieExists) {
      cIdToken = this.cookieService.get("idToken");
      cRefreshToken = this.cookieService.get("refreshToken");
      cAccessToken = this.cookieService.get("accessToken");
    }

    if (!this.userState?.getUserDetails || !this.userState.getUserDetails?.id) {
      if (cIdToken && cAccessToken && cRefreshToken) {
        this.clearLocalStorage();
        this.validateLogin();
      } else {
        this.clearLocalStorage();
        this.cookieStorageService.clearAllCookies();
        this.refresh();
      }
    } else {
      this.isLoggedIn = true;
      this.displayname = this.userState?.getUserDetails?.userFullName;
    }
  }

  validateLogin() {
    this.loginService.ValidateLogin().subscribe({
      next: (res) => {
        if (res && res.user_profile) {
          let userDetails = res.user_profile;
          userDetails['id'] = res.id;
          userDetails['userName'] = res.userName;
          userDetails['userType'] = res.userType;
          userDetails['userFullName'] = res.user_profile.firstName + ' ' + res.user_profile.lastName;
          this.userState.getUserDetails = userDetails;

          this.refresh();

          if (this.path == '/my-listing') {
            this.loadListings.emit();
          }
        } else {
          console.log('Login Fails!!!!');
        }
      },
      error: (err) => {
        console.log('ValidateLogin :err', err);
      },
    });

  }

  refresh() {
    let userId = this.userState?.getUserDetails?.id;
    let userFullName = this.userState?.getUserDetails?.userFullName;
    let userEmail = this.userState?.getUserDetails?.email;
    if (userId && userFullName && userEmail) {
      this.isLoggedIn = true;
      this.displayname = userFullName;

      if (userEmail && !this.userState?.getUserDetails) {
        this.getUserInfo(userEmail);
      }

      if (this.path == '/signin') {
        this.loadSavedSearches(userId);
      }
    } else {
      this.isLoggedIn = false;
    }
  }

  getUserInfo(userName) {
    let input = {
      where: {
        email: encodeURIComponent(userName),
      },
    };
    this.userService.GetUsers(input).subscribe({
      next: (res) => {

        if (res && res.length > 0) {
          let user = res[0];
          this.userState.getUserDetails = user;
        } else {
          console.log('GetUsers Fails!!!! :', res);
        }
      },
      error: (err) => {
        console.log('GetUsers err : ', err);
      },
    });
  }

  loadSavedSearches(userId) {
    let input = {
      where: {
        userId: userId,
      },
      order: 'id DESC',
    };
    this.myListingsService.GetListings(input).subscribe({
      next: (res) => {
        if (res && res.length > 0) {
          this.router.navigateByUrl('/my-listing');
        } else {
          this.router.navigateByUrl('');
          console.log('GetListings Fails!!!!');
        }
      },
      error: (err) => {
        this.router.navigateByUrl('');
        console.log('GetListings err : ', err);
      },
    });
  }

  signUp() {
    this.clearLocalStorage();
    this.cookieStorageService.clearAllCookies();
    this.router.navigateByUrl('/signup');
  }

  login() {
    this.clearLocalStorage();
    this.cookieStorageService.clearAllCookies();
    this.router.navigateByUrl('/signin');
  }

  clearLocalStorage() {
    this.userState.getUserDetails = null;

    this.localStorageService.remove('myListingId');
    this.localStorageService.remove('addressInfo');
    this.localStorageService.remove('lcAccessToken');
    this.localStorageService.remove('appQueryParams');
  }

  logOut() {
   
    this.loginService.UserLogout().subscribe({
      next: (res) => {
        if (res) {
          console.log('Logout res : ', res);
        } else {
          console.log('Logout Fails!!!!');
        }
      },
      error: (err) => {
        console.log('Logout :err', err);
      },
    });

    this.clearLocalStorage();
    this.cookieStorageService.clearAllCookies();
    window.open(this.websiteUrl, "_self");
  }

  moveToWP() {
    this.localStorageService.remove('myListingId');
    this.localStorageService.remove('addressInfo');
    this.localStorageService.remove('lcAccessToken');

    window.open(this.websiteUrl, "_self");
  }

  myListings() {
    this.router.navigateByUrl('/my-listing', {
      state: this.historyState
    });
  }

  myAccount() {
    window.open("https://" + this.appState.companyInfoValue?.baseUrl + "/profile", "_self");
  }

  addListing() {
    this.localStorageService.remove('myListingId');
    this.localStorageService.remove('addressInfo');
    this.localStorageService.remove('lcAccessToken');
    this.router.navigateByUrl('');
  }

  public toggleNav(from): void {
    if (from == "nav") {
      this.isNaveEnabled = !this.isNaveEnabled;
    } else if (from == "buy") {
      this.isBuy = !this.isBuy;
    } else {
      this.isSell = !this.isSell;
    }
  }
}
